export const GET_EOL_RESULTS = "eolresults.GET_EOL_RESULTS";
